import React from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import ReactLoading from 'react-loading';
import DataProcessing from '../assets/data_processing_icon.svg';


const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    width:'50vw',
    height:'40vw',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};



function WaitModal(props) {




  return (
    <Container>

      <Modal
        isOpen={props.modalIsOpen}
        style={customStyles}
         ariaHideApp={false}
        contentLabel="Example Modal"
      >


        <ModalContainer>
            <h2 >Please Wait</h2>
            <Img src={DataProcessing}/>
           <ReactLoading type="bubbles" color="#69ACC7" height={'15%'} width={'15%'} />
             <P>Data processing...</P>
        </ModalContainer>



      </Modal>
    </Container>
  );
}




const Container = styled.div`
    font-family:'Fira Sans';
`;

const P = styled.p`
    font-family:'Fira Sans';
`;
const Img =styled.img`
    height:200px;
    width:200px;
`;

const ModalContainer = styled.div`
    display: flex;
    justify-content:space-around;
    flex-direction:column;
    align-items:center;
    height:100%;


`;


export default WaitModal;



// WEBPACK FOOTER //
// ./src/components/waitModal.js